export default __webpack_public_path__ + "static/media/requestFirstStage.d6c7e02c.svg";